<span id="{{ this.componentID() }}" class="number tw-font-roboto-condensed !tw-w-full"></span>
